import { render } from "./g-date-input.vue?vue&type=template&id=e1aa6b8a&scoped=true"
import script from "./g-date-input.vue?vue&type=script&lang=js"
export * from "./g-date-input.vue?vue&type=script&lang=js"

import "./g-date-input.vue?vue&type=style&index=0&id=e1aa6b8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1aa6b8a"]])

export default __exports__